const path = "redux/Snackbar";
export const TOGGLE_SNACKBAR_OPEN = `${path}/TOGGLE_SNACKBAR_OPEN`;
export const TOGGLE_SNACKBAR_CLOSE = `${path}/TOGGLE_SNACKBAR_CLOSE`;
